import { ReactElement } from 'react';
/* eslint-disable max-len */
export const StreamlinesRoute = ({ fill = 'none', stroke = 'currentColor' }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 36 36">
      <circle {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" cx="9" cy="9" r="3" />
      <circle {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" cx="27" cy="27" r="3" />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        d="M12,9 L18,9 Q24,9 24,15 L24,21 Q24,27 18,27 L24,27"
      />
      <circle {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" cx="18" cy="18" r="2" />
    </svg>
  );
};
/* eslint-enable max-len */
